import { useState } from "react";
import { PASSWORD_MIN, PASSWORD_RULE, passwordRuleError } from "./authApi";

/**
 * M02, the password rule: stated before typing ("At least 10 characters."),
 * it turns into the error in place when the field is left short or the form
 * is sent, and the tenth character clears it at once.
 */
export function usePasswordRule() {
  const [value, setValue] = useState("");
  const [shown, setShown] = useState(false);
  const error = shown ? passwordRuleError(value) : null;

  return {
    value,
    error,
    hint: PASSWORD_RULE,
    field: {
      value,
      onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
        setValue(e.target.value);
        if (e.target.value.length >= PASSWORD_MIN) setShown(false);
      },
      onBlur: () => {
        if (value.length > 0 && value.length < PASSWORD_MIN) setShown(true);
      },
    },
    /** On send: true when the rule holds, else the error shows. */
    check: () => {
      const ok = value.length >= PASSWORD_MIN;
      setShown(!ok);
      return ok;
    },
  };
}
